import { type ComponentPropsWithoutRef } from 'react';

import { cn } from '@/utils/cn';

export interface SpinnerProps extends Omit<ComponentPropsWithoutRef<'span'>, 'children'> {
  /** Localized. Required by the type: an unnamed `role="status"` is an unreadable loading state. */
  label: string;
  size?: 'sm' | 'md' | 'lg';
}

const SIZES = {
  sm: 'size-4 border-2',
  md: 'size-5 border-2',
  lg: 'size-8 border-[3px]',
} as const;

/**
 * Never used alone for a screen-level load — `Skeleton` is, so the merchant's brand appears in the
 * first frame. This is for in-control busy states, chiefly inside `Button`.
 */
export function Spinner({ label, size = 'md', className, ...rest }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn('inline-flex shrink-0 items-center justify-center', className)}
      {...rest}
    >
      <span
        aria-hidden="true"
        className={cn(
          'animate-spin rounded-full border-current border-e-transparent',
          SIZES[size],
        )}
      />
    </span>
  );
}
